import baseGet from './_baseGet';
import baseSlice from './_baseSlice';

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
}

export default parent;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_parent.js
// module id = 396
// module chunks = 0